import { gql } from 'src/generated/gql';

export const COMPLETE_PRESCRIPTION_TASK = gql(`
  mutation CompletePrescriptionTask($taskId: ID!) {
    staff_completePrescriptionTask(taskId: $taskId) {
      id
      eventId
      status
    }
  }
`);
